

export class PlayScene extends Phaser.Scene {
    world = 1;
    cursors:any = null;
    fondo: any = null;
    pointer: any = null;
    btonFire: any = null;
    lastFired:number = 0;
    lastObject: number = 0;
    lastObjectRight: number = 0;
    player:any = null;
    truenos:any = null;
    objectBad: any = null;
    objectGood: any = null;
    platforms:any =null;
    platformsLateral: any = null;
    platformsLateralLeft: any = null;
    public handleChangePoints:any;
    rayo:string ='rayito';
    ayuda:boolean =false;


    velocityObjects:number = 300;
    puntosGood:number = 2;

    constructor(handleChangePoints: any, ayuda:boolean) {
        super({
            key: 'PlayScene',
            physics: {
                default: 'arcade',
                arcade: {
                    
                }
            }
        });
        this.handleChangePoints = handleChangePoints;
        this.ayuda = ayuda;
    }

    public preload() {
        this.fondo=this.add.image(0, 0, 'fondo').setOrigin(0, 0);
        this.player = this.add.image(300, 530, 'player');
        this.btonFire = this.add.image(560, 560, 'btnShooter');
        this.platforms = this.physics.add.staticImage(400, -50, 'platform');
        this.platformsLateral = this.physics.add.staticImage(750, 130, 'platform_lateral');
        this.platformsLateralLeft = this.physics.add.staticImage(-150, 130, 'platform_lateral');
        if (this.ayuda){
            this.rayo='rayito2';
            this.puntosGood=4;
        }
    }

    public create() {
        this.cursors = this.input.keyboard.createCursorKeys();
        this.pointer = this.input.activePointer;
        this.truenos = this.physics.add.group();
        this.objectBad = this.physics.add.group();
        this.objectGood = this.physics.add.group();
       
        this.physics.add.collider(this.truenos, this.objectBad, this.colliderObject, () => this.handleChangePoints(this.puntosGood));
        this.physics.add.collider(this.truenos, this.objectGood, this.colliderObjectGood, () => this.handleChangePoints(-1));
        //mobile
        this.btonFire.setInteractive({ draggable: true });
        this.btonFire.on('pointerdown', (pointer: any) => {
            var trueno = this.truenos.create(this.player.x + 48, this.player.y - 100, this.rayo).setVelocity(0, -800).setBounce(1, 1);
            this.physics.add.collider(trueno, this.platforms, this.collider);
        }, this);
        this.fondo.setInteractive({ draggable: true });
        this.fondo.on('pointerdown', (pointer:any) => {
            var touchX = pointer.x;
            if (touchX > 540) {
                this.player.x = 540;
            } else {
                this.player.x = touchX;
            }
            // ...
        },this);
        
    }
    public update(time:number) {   
        
        //pc
        if (this.cursors.space.isDown && time > this.lastFired) {
            var trueno = this.truenos.create(this.player.x + 48, this.player.y - 100, this.rayo).setVelocity(0, -800).setBounce(1, 1);
            this.physics.add.collider(trueno, this.platforms, this.collider);
            this.lastFired = time + 200;
        }
        if (this.cursors.left.isDown && this.player.x > -20) {
            this.player.x -= 5;
        }
        else if (this.cursors.right.isDown && this.player.x < 540) {
            this.player.x += 5;
        }  
        if (time > this.lastObject) {
            var value = Phaser.Math.Between(0, 1);
            var objectAnimation;
            if (value < 1){
                var randomFrase = Phaser.Math.Between(1, 5);
                objectAnimation = this.objectBad.create(-50, 60, 'Obstacle' + randomFrase).setVelocity(this.velocityObjects, 0).setBounce(1, 1);
            }else{
                objectAnimation = this.objectGood.create(-50, 60, 'corazon').setVelocity(this.velocityObjects, 0).setBounce(1, 1);
            }
            this.physics.add.collider(objectAnimation, this.platformsLateral, this.collider);
            this.lastObject = time + Phaser.Math.Between(500, 1000);
            this.tweens.add({
                targets: objectAnimation,
                y: 70,
                duration: 500,
                ease: 'Quad.easeInOut',
                delay: 1,
                yoyo: true,
                repeat: -1
            });
        }
        if (time > this.lastObjectRight) {
            var value = Phaser.Math.Between(0, 1);
            var objectAnimation;
            if (value < 1 ) {
                var randomFrase = Phaser.Math.Between(1, 5);
                objectAnimation = this.objectBad.create(650, 120, 'Obstacle' + randomFrase).setVelocity(-this.velocityObjects, 0).setBounce(1, 1);
            } else {
                objectAnimation = this.objectGood.create(650, 120, 'corazon').setVelocity(-this.velocityObjects, 0).setBounce(1, 1);
            }
            this.physics.add.collider(objectAnimation, this.platformsLateralLeft, this.collider);
            this.lastObjectRight = time + Phaser.Math.Between(500, 2000);
            this.tweens.add({
                targets: objectAnimation,
                y: 130,
                duration: 500,
                ease: 'Quad.easeInOut',
                delay: 1,
                yoyo: true,
                repeat: -1
            });
        }
    }
    public collider(obt: any, platform:any){
        obt.destroy();
    }
    public colliderObject(truenos: any, objectBad: any) { 
        truenos.destroy();
        objectBad.destroy();
    }
    public colliderObjectGood(truenos: any, objectGood: any) {
        truenos.destroy();
        objectGood.destroy();
    }
}
